import { createFileRoute, redirect } from '@tanstack/react-router'
import PageLayout from '../components/layout/PageLayout/PageLayout'
import { WithNodesQuery } from '../components/data/WithNodesQuery/WithNodesQuery'
import useAuthStore from '../stores/useAuthStore/useAuthStore'
import { useApi } from '@/hooks'
import { AppWalkthrough } from '../components/organisms/AppWalkthrough/AppWalkthrough'

const RouteComponent: React.FC = () => {
    const { useCurrentUserQuery, useCustomersQuery } = useApi()
    useCurrentUserQuery()

    const user = useAuthStore((state) => state.user)
    useCustomersQuery(user)

    return (
        <WithNodesQuery>
            <PageLayout />
            <AppWalkthrough />
        </WithNodesQuery>
    )
}

export const Route = createFileRoute('/_layout')({
    beforeLoad: ({ location }) => {
        const { accessToken, sessionId, clearSession } = useAuthStore.getState()

        const search =
            location.search instanceof Error ||
            Object.entries(location.search).length === 0
                ? ''
                : `?${new URLSearchParams(
                      Object.fromEntries(
                          Object.entries(location.search).map(
                              ([key, value]) => [
                                  key,
                                  typeof value === 'string'
                                      ? value
                                      : String(value),
                              ]
                          )
                      )
                  )}`

        if (!accessToken || !sessionId) {
            clearSession()
            redirect({
                to: '/login',
                search: {
                    redirectTo: `${location.pathname}${search}`,
                },
                throw: true,
            })
        }

        return true
    },
    component: RouteComponent,
})
